"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withDroppable = void 0;
const tslib_1 = require("tslib");
const react_dnd_1 = require("react-dnd");
const withFileSystemContext_1 = require("../withFileSystemContext");
const lib_1 = require("../../../lib");
function withDroppable(type, canDropTypes) {
    return function (WrappedComponent) {
        return (0, lib_1.compose)((0, withFileSystemContext_1.withFileSystemContext)((context) => ({ context })), (0, react_dnd_1.DropTarget)(canDropTypes, {
            hover(props, monitor) {
                if (props.onHover && monitor.canDrop())
                    props.onHover(props.context.state.selectedItems.length > 1
                        ? props.context.state.selectedItems
                        : [monitor.getItem().item], props.item);
            },
            drop(props, monitor) {
                const { onDrop, item } = props, rest = (0, tslib_1.__rest)(props, ["onDrop", "item"]);
                if (onDrop)
                    onDrop(props.context.state.selectedItems.length > 1
                        ? props.context.state.selectedItems
                        : [monitor.getItem().item], item);
                if (props.context.props.onAddToFolder)
                    props.context.props.onAddToFolder(props.context.state.selectedItems.length > 1
                        ? props.context.state.selectedItems
                        : [monitor.getItem().item], item);
                return {
                    type,
                    props: rest,
                    item: rest.item,
                };
            },
            canDrop(props, monitor) {
                if (props.context.state.selectedItems.length > 1) {
                    return !props.context.state.selectedItems.some((item) => item.path === props.item.path);
                }
                return props.item.path !== monitor.getItem().item.path;
            },
        }, (connect, monitor) => {
            return {
                connectDropTarget: connect.dropTarget(),
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop(),
            };
        }))(WrappedComponent);
    };
}
exports.withDroppable = withDroppable;
//# sourceMappingURL=withDroppable.js.map